module.exports = __webpack_public_path__ + "assets/img/14_1361_big.8b8a6df0.jpg";